export const PHONE_INPUT_MAX_LENGTH = 10;
export const PHONE_INPUT_PATTERN = '[0-9]*';
export const PHONE_INPUT_TITLE = 'Enter a 10 digit phone number';

export const normalizePhoneInput = (value: string): string => value.replace(/\D/g, '').slice(0, PHONE_INPUT_MAX_LENGTH);

export const isPhoneFieldName = (value: string): boolean => (
  /(?:phone|mobile|whatsapp|contactnumber|contactphone|phoneno|emergencyphoneno|alternativenumber|guardiancontactno)/i.test(value.replace(/[\s_.-]/g, ''))
);

